<template>
  <div class="setting">
    <div class="picture-part">

        <div class="img-width">
          <v-dialog
            v-model="dialog2"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            width="100%"
          >
            <template v-slot:activator="{ on, attrs }">
              <button
                class="btn open-image-btn"
                v-bind="attrs"
                v-on="on"
              >
                <img :src="user_image" class="" />

              </button>
            </template>

            <v-card class="edit-picture blue-border">
              <v-toolbar
                dark
                color="primary"
              >
                <v-btn
                  icon
                  dark
                  @click="dialog2 = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
<!--                <v-toolbar-title>گالری</v-toolbar-title>-->
                <v-spacer></v-spacer>

              </v-toolbar>

              <v-card-text>

                <VueSlickCarousel :arrows="true" :dots="false">
                  <div v-for="item in photos" class="full-screen-photos">
                    <img :src="item.ImageUrl" />
                    <div class="text-center delete-photos">
                      <button v-on:click="deletePhoto(item)">
                        <v-icon>
                          mdi-delete
                        </v-icon>
                      </button>
                    </div>

                  </div>

                </VueSlickCarousel>
              </v-card-text>


            </v-card>
          </v-dialog>

        </div>
        <div class="name-width">
          <span class="name">
            {{ user_name }}
          </span>
          <p class="mobile">
           {{ user_mobile }}
          </p>
        </div>
        <div class="add-width">
          <v-dialog
            v-model="dialog"
            width="500"
          >
            <template v-slot:activator="{ on, attrs }">
              <button
                class="btn"
                v-bind="attrs"
                v-on="on"
              >
                  <v-icon>
                    mdi-plus
                  </v-icon>
              </button>
            </template>

            <v-card class="edit-picture blue-border">
              <div class="edit-header">{{ $t('editProfile') }}<img src="../../../public/img/zoodkomak.png" />
              </div>

              <v-card-text>
                <ul>
                  <li @click="select_file()">
                    انتخاب از گالری
                  </li>
                  <li @click="openCamera()">
                    انتخاب از دوربین
                  </li>
                  <li @click="delete_file()">
                   حذف تصویر
                  </li>
                </ul>
              </v-card-text>
              <input id="fileUpload" type="file" hidden v-on:change="input_file_changed">
              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="dialog = false"
                >{{ $t('cancel') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


        </div>

    </div>

    <div class="option-part">
      <div class="profile" v-on:click="goToProfile()">
        <span>{{ $t('profile') }}</span>
        <v-icon>
          mdi-account
        </v-icon>
      </div>
      <div class="change-password" v-on:click="goToPassword()">
        <span>{{ $t('changePassword') }}</span>
        <v-icon>
          mdi-key
        </v-icon>
      </div>
    </div>
  </div>

</template>
<script>
  import { Carousel, Slide } from 'vue-carousel';
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import {bus} from "../../main";
  export default {
    data(){
      return {
        files: [],
        user_name :'',
        dialog_camera: false,
        isCameraOpen: false,
        user_mobile :'',
        user_image :'',
        dialog: false,
        dialog2: false,
        items: '',
        password: '',
        photos: '',
      }
    },
    components: { VueSlickCarousel },
    mounted() {
      this.profile();
      this.GetUserImages();
    },
    methods:{
      deletePhoto(item){
        const send_data = {
          "ImageId": item.ImageId,
          "Phone": this.user_mobile,
          "Password": this.password,
          "ImageName": item.ImageUrl,
        };
        var self = this;
        this.axios.post('/DeleteImage' , send_data,{})
          .then(response => {
            if(response.data.error == 0) {
              console.log("delete  " , response)

              // self.user_info = response.data.userInfo;
            }
            else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }

          }).catch(e => {

        })
      },
      GetUserImages() {
        const send_data = {
          "UserId":this.items.UserId,
          "RecType": 0,
        };
        var self = this;
        this.axios.post('/GetUserImages' , send_data,{})
          .then(response => {
            if(response.data.error == 0) {
              console.log("user info" , response.data.imgs)
              self.photos = response.data.imgs;
              // self.user_info = response.data.userInfo;
            }

          }).catch(e => {

        })
      },
      select_file() {
        document.getElementById("fileUpload").click()
      },
      delete_file(){
        this.files = [];
      },
      openCamera(){
        this.isCameraOpen = true;
        this.createCameraElement();
        this.dialog_camera = true;
      },
      createCameraElement() {
        try {
          const constraints = (window.constraints = {
            audio: false,
            video: true
          });

          navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
              this.$refs.camera.srcObject = stream;
            })
            .catch(error => {
              alert(this.$t('deviceHasNotSupportCamera'));
            });
        } catch (err) {
          alert(err)
        }

      },
      input_file_changed() {
        var self = this;
        var reader = new FileReader();
        var f = document.getElementById("fileUpload").files;
        reader.onloadend = function () {
          var obj = {file: reader.result, preview: reader.result, upload: 0}
          self.files.push(obj);
        }
        reader.readAsDataURL(f[0]);

      },
      profile(){
        var user_data = JSON.parse(localStorage.getItem("profile"));
        console.log("user_data ", user_data)
        this.items = user_data;
        console.log(user_data)
        this.user_name = user_data.UserName
        this.user_image = user_data.ThumbPath
        this.user_mobile = localStorage.getItem("phone")
        this.password = localStorage.getItem("password")
      },
      goToProfile(){
        this.$router.push({name:this.$t('editProfile'),params:{}})
      },
      goToPassword() {
        this.$router.push({name:this.$t('sendCode'),params:{}})
      }
    }
  }
</script>
